module.exports = __webpack_public_path__ + "static/img/icon02.8e2f0f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/icon02.png
// module id = /kAh
// module chunks = 1